"use client";

import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";
import { ArrowRight } from "lucide-react";
import { motion } from "motion/react";
import { GridSvg } from "@/components/gridSvg";

export default function ServicesAndProducts() {
  return (
    <section className={"wrapper md:py-[100px] relative"}>
      <GridSvg />
      <motion.div
        initial={{ opacity: 0, y: 150 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className={"flex flex-col gap-5  items-center "}
      >
        <Badge>Our Services & Products</Badge>
        <h1 className={"text-4xl font-bold text-center"}>
          Comprehensive Solutions Across
          <br />
          <span className={"text-primary underline"}>Multiple Industries</span>
        </h1>
        <p
          className={"text-center font-semibold text-muted-foreground text-lg"}
        >
          We provide cutting-edge technology solutions across seven key sectors,
          bringing <br /> innovation to every corner of Bhutan&apos;s economy.
        </p>

        <div className={"grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-5"}>
          {siteConfig.services.map((service, index) => (
            <motion.div
              initial={{ opacity: 0, y: 150 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: index * 0.1 }}
              key={index}
            >
              <div className="square-gradient-bg   text-background bg-background h-full transition-all duration-500 hover:shadow-2xl hover:shadow-emerald-500/10">
                <div className="p-8 h-full flex flex-col">
                  <div className="relative mb-6">
                    <div
                      className={`absolute inset-0 bg-gradient-to-r rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
                    />
                    <div
                      className={`relative bg-primary w-16 h-16 rounded-2xl bg-gradient-to-r flex items-center justify-center group-hover:scale-110 transition-transform duration-500`}
                    >
                      <service.icon className="h-8 w-8 text-white" />
                    </div>
                  </div>

                  <h3 className="text-xl text-primary font-semibold mb-4 text-muted-foreground group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </h3>

                  <p className="text-slate-400 leading-relaxed flex-grow">
                    {service.description}
                  </p>

                  <div className="mt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ArrowRight className="h-5 w-5 text-primary" />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
